import type { Translatable } from "app/pages/sales-intelligence/types";

import { FilterPanelBaseFilter } from "./BaseFilter";

export type PendingFilterOptions = {
    readonly bodyText: Translatable;
};

/**
 * Inert model behind a pending placeholder card. The inherited pass-through `affectValue` is load-bearing:
 * `updateFilters` deletes any key whose `affectValue` returns undefined, and a saved DTO value must survive
 * while the real filter's data loads. Only emptiness is overridden — the base reports `undefined` as non-empty.
 */
export class PendingFilterModel extends FilterPanelBaseFilter<unknown, PendingFilterOptions> {
    constructor(options: PendingFilterOptions) {
        super({ options });
    }

    // fallow-ignore-next-line unused-class-member
    override isValueEmpty(value?: unknown): boolean {
        return value == null || super.isValueEmpty(value);
    }
}
